// React
import React from "react";

// Redux
import {connect} from "react-redux";
import {push} from 'connected-react-router'
import * as actions from "../../../../store/actions";

// Tools
import i18n from "../../../../i18n";

// Components
import {Button, Form, Spinner, BottomBar} from "../../../../components";
import {filterFormValues} from "../../../../components/Form/formTools";
import {TitleWrapper} from "../../../../contexts/TitleProvider";

const distributorForm = {
    name: {label: i18n.distributorName},
    row1: {
        type:  "row",
        items: {
            address: {label: i18n.distributorAddress, size: 8},
            zipcode: {label: i18n.distributorZipcode, size: 4, validation: {required: true, minLength: 4}},
        }
    },
    row2: {
        type:  "row",
        items: {
            city:    {label: i18n.distributorCity, size: 4},
            state:   {label: i18n.distributorState, size: 4},
            country: {label: i18n.distributorCountry, size: 4}
        }
    },
    row3: {
        type:  "row",
        items: {
            phone: {label: i18n.distributorPhone, size: 6},
            email: {label: i18n.distributorEmail, size: 6, validation: {required: true, isEmail: true}}
        }
    }
};

class Edit extends React.Component {
    state = {
        uuid:        null,
        distributor: null,
        formValues:  {},
        formValid:   false
    };

    constructor(props) {
        super(props);
        this.state.uuid = props.match.params.distributor;
        if (this.state.uuid.length !== 32) {
            props.push("/admin/distributors");
            return;
        }

        if (props.distributors) {
            this.state.distributor = this.props.distributors.find(obj => obj.uuid === this.state.uuid);
            this.state.formValues  = filterFormValues(distributorForm, this.state.distributor);
        } else {
            if (!props.loading) {
                props.load();
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props === prevProps) {
            return;
        }

        // If the distributor store suddenly changed, update the details
        if (this.props.distributors && this.props.distributors !== prevProps.distributors && this.props.distributors.length > 0) {
            let uuid        = this.props.match.params.distributor;
            let distributor = this.props.distributors.find(obj => obj.uuid === uuid);
            if (distributor) {
                this.setState({distributor, formValues: filterFormValues(distributorForm, distributor)});
            } else {
                // Unknown distributor, go back to caretaker overview
                this.props.push("/admin/distributors");
            }
        }
    }

    handleChange = (formValues, formValid) => this.setState({formValues, formValid});
    handleValid  = formValid => this.setState({formValid});
    handleSubmit = () => this.state.formValid && this.props.save(this.state.uuid, this.state.formValues);

    render() {
        return (
            <TitleWrapper title={i18n.distributorsEditTitle}>
                <div>
                    <div className="content">
                        {this.state.distributor && !this.props.loading && !this.props.saving ? (
                            <>
                                <Form
                                    formData={distributorForm}
                                    values={this.state.formValues}
                                    onChange={this.handleChange}
                                    onValid={this.handleValid}
                                    stacked
                                />
                                <Button round color="info" block disabled={!this.state.formValid} onClick={this.handleSubmit}>
                                    {i18n.buttonSave}
                                </Button>
                            </>
                        ) : <Spinner/>}
                        <BottomBar backButton/>
                    </div>
                </div>
            </TitleWrapper>
        );
    }
}

const mapStateToProps = state => ({
    loading:      state.distributors.loading,
    saving:       state.distributors.saving,
    distributors: state.distributors.distributors
});

const mapDispatchToProps = dispatch => ({
    push: pathname => dispatch(push(pathname)),
    load: () => dispatch(actions.distributors.load()),
    save: (uuid, details) => dispatch(actions.distributors.save(uuid, details))
});

export default connect(mapStateToProps, mapDispatchToProps)(Edit);
